export default "__VITE_ASSET__CbTuEVEB__"